// extracted by mini-css-extract-plugin
module.exports = {"orders":"orders_orders__KqF-Z"};